import { useCallback, useEffect, useState } from "react";

const KEY = "ka.focusMode";

function apply(on: boolean) {
  if (typeof document === "undefined") return;
  if (on) document.documentElement.setAttribute("data-focus", "on");
  else document.documentElement.removeAttribute("data-focus");
}

export function useFocusMode(): [boolean, (v?: boolean) => void] {
  const [on, setOn] = useState(false);

  // Rehydrate persisted preference.
  useEffect(() => {
    try {
      const v = window.localStorage.getItem(KEY) === "1";
      setOn(v);
      apply(v);
    } catch { /* noop */ }
  }, []);

  const toggle = useCallback((v?: boolean) => {
    setOn((prev) => {
      const next = typeof v === "boolean" ? v : !prev;
      try { window.localStorage.setItem(KEY, next ? "1" : "0"); } catch { /* noop */ }
      apply(next);
      return next;
    });
  }, []);

  return [on, toggle];
}
